var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-form"},[_c('Header'),_c('Merchant'),_c('section',{staticClass:"main"},[_c('Fix')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }